import { render, staticRenderFns } from "./ResetClient.vue?vue&type=template&id=7e35ce8f&scoped=true&"
import script from "./ResetClient.vue?vue&type=script&lang=js&"
export * from "./ResetClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e35ce8f",
  null
  
)

export default component.exports